import useSpecialties from "hooks/useSpecialties";
import { useEffect, useState } from "react";
import TableSpecialties from "views/admin/specialties/components/TableSpecialties";
import InputSpecialties from "views/admin/specialties/components/InputSpecialties";
import SectionTitle from "components/sectionTitle";

const Specialties = () => {
  const { response, isLoading, fetchData } = useSpecialties();
  const [editData, setEditData] = useState(null);  // Estado para la especialidad que se va a editar

  useEffect(() => {
    fetchData();
  }, []);

  // Función para manejar la especialidad seleccionada desde TableSpecialties
  const handleEdit = (dataEdit) => {
    setEditData(dataEdit);
  };

  return (
    <div>
      <SectionTitle eyebrow="Configuración">Especialidades</SectionTitle>
      <div className="grid grid-cols-1 items-start gap-5 lg:grid-cols-3">
        <div className="lg:col-span-1">
          <InputSpecialties specialties={response} isLoading={isLoading} editData={editData} />
        </div>
        <div className="lg:col-span-2">
          <TableSpecialties isLoading={isLoading} data={response} onEdit={handleEdit} />
        </div>
      </div>
    </div>
  );
};

export default Specialties;
